<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>{{ campaign_status }} Campaigns</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> 

          {{ viewing_as_full_name ? 'Viewing As : ' +  viewing_as_full_name : null }}
        </vs-col>
      </vs-row>
      <DataGrid :context="'Clientcampaigns'" ref="campaigns" :columnDefs="campaignsColumnDefs" :rowData="campaignsRecords"
        @showClientUserLive="showClientUserLive" @showClientUserInsights="showClientUserInsights"
         :dataSource="campaignsDataSource">
      </DataGrid>
    </vx-card>

  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    client_user_id: null,
    viewing_as_full_name: null,
    user_id: null,
    user_role: null,
    campaign_status: null,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Code",
        field: "campaign_code",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign",
        field: "campaign_name",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        cellRenderer: function(params){
          console.log(params)
      return "<a href='/client-dashboard/client_campaign_view/" 
        + params.data.campaign_id
        + "'>"+params.value+"</a>";
    }
      },

      {
        headerName: "Start Date",
        field: "start_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Status",
        field: "campaign_status",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {

        headerName: "Stats",
        cellRenderer: params => {
          let eIconGui = document.createElement("span");
          return (eIconGui.innerHTML =
            '<em class="material-icons">bar_chart</em>');
        },
        width: 140,
        sortable: false,
        field: "client-user-stats"
        // headerName: "Stats",
        // field: "end_date",
        // filter: "agTextColumnFilter",
        // filterParams: {
        //   buttons: ["apply", "reset"],
        //   maxNumConditions: 4
        // }
      },
      {
        headerName: "Gantt",
        field: "client-user-gantt",
        width: 140,
        cellRenderer: params => {
          let eIconGui = document.createElement("span");
          return (eIconGui.innerHTML =
            '<em class="material-icons">account_tree</em>');
        },
        sortable: false

      },
      {
        headerName: "Live",
        field: "client-user-live",
        width: 140,
        cellRenderer: params => {
          let eIconGui = document.createElement("span");
          return (eIconGui.innerHTML =
            '<em class="material-icons">live_tv</em>');
        },
        sortable: false


      },
      {
        headerName: "Target %",
        field: "target",
        width: 140,


      },
      {
        headerName: "Opp",
        field: "opportunity",
        width: 140,
      },
      {
        headerName: "Insights",
        field: "client-user-insights",
        width: 120,
        cellRenderer: params => {
          let eIconGui = document.createElement("span");
          return (eIconGui.innerHTML =
            '<em class="material-icons">show_chart</em>');
        },
        sortable: false


      },
      
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignFieldsManagement,
    DataGrid
  },
  watch: {},
  methods: {
    showClientUserLive(data) {
      let self = this;
      self.$router.push(
              "/client-campaign-view/live-account-contact/" +
              data.campaign_id + '/' + self.$route.params.client_id + '/' +  self.$route.params.client_user_id
            );
    },
    showClientUserInsights(data) {
      let self = this;
      let route = self.$router.resolve({path: "/client-dashboard/dashboard/" +data.campaign_id});
      window.open(route.href, '_blank');
    },
    getAdminClientAndUserViewCampaignDataSource() {
      var self = this;
      this.campaignsDataSource = {
        getRows(params) {

          params.request.client_user_id = self.$route.params.client_user_id
          params.request.client_id = self.$route.params.client_id
          params.request.campaign_status = self.campaign_status
          self.$store
            .dispatch(
              "campaignsManagement/getAdminClientAndUserViewCampaignDataSource",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;


              console.log(response_data)
              if (response_data.length != 0) {
                self.$refs.campaigns.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.campaigns.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getAdminClientAndUserViewCampaignDataSource();
  },
  mounted() {
    this.viewing_as_full_name = atob(this.$route.params.client_user_full_name)
    this.client_user_id = this.$route.params.client_user_id
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });


    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    self.campaign_status = this.$route.params.campaign_status

    if (this.user_role == 'Sales Developer'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }


    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
